const REFRESH_ENABLED = 'REFRESH_ENABLED';
const REFRESH_DISABLED = 'REFRESH_DISABLED';

export {
  REFRESH_ENABLED,
  REFRESH_DISABLED
};
